import type { ObbTakeoffData } from './obbTakeoff';

// Kitchen island takeoff for the Kimbark Residence.
// Source: ~/Downloads/labels_aligned/counter_03_bbox.txt (Stefan SI extraction).
// Coordinates: raw scene-3 Z-up. world_x=raw_x, world_y=raw_z, world_z=-raw_y.
// P0-P3 bottom (raw_z≈-1.39), P4-P7 top (raw_z≈-0.42). Pi↔P(i+4) verticals.
// Rectangle: P0-P1 & P2-P3 long sides (8'5"), P0-P2 & P1-P3 short sides (4'2").

const P: [number, number, number][] = [
  [1.7165, -7.7840, -1.3921],  // P0 bottom
  [2.5814, -5.3687, -1.3622],  // P1 bottom
  [0.5227, -7.3564, -1.3952],  // P2 bottom
  [1.3877, -4.9412, -1.3653],  // P3 bottom
  [1.7104, -7.7938, -0.4234],  // P4 top
  [2.5754, -5.3786, -0.3935],  // P5 top
  [0.5166, -7.3663, -0.4265],  // P6 top
  [1.3816, -4.9510, -0.3966],  // P7 top
];

const mid = (a: [number,number,number], b: [number,number,number]): [number,number,number] =>
  [(a[0]+b[0])/2, (a[1]+b[1])/2, (a[2]+b[2])/2];

const off = (p: [number,number,number], d: [number,number,number]): [number,number,number] =>
  [p[0]+d[0], p[1]+d[1], p[2]+d[2]];

// Short axis (P0→P2): (-0.941, 0.338, 0) × 0.3m
const SA: [number,number,number] = [-0.28, 0.10, 0];
// Long axis (P0→P1): (0.337, 0.942, 0) × 0.3m
const LA: [number,number,number] = [0.10, 0.28, 0];

export const KIMBARK_KITCHEN_TAKEOFF: ObbTakeoffData = {
  title:             'Kitchen Takeoff',
  subtitle:          'Ground Floor',
  elementLabel:      'Kitchen Island',
  elementDimensions: "8' 5\" × 4' 2\" × 38\"",
  scanLabel:         'Scan 5',
  color:             '#0CB4E4',  // Cr3ate amber

  obbPoints: P,

  dimensionAnchors: {
    a: { point: off(mid(P[0], P[1]), SA), label: "8' 5\"" },   // long side
    b: { point: off(mid(P[0], P[2]), LA), label: "4' 2\"" },   // short side
    c: { point: off(mid(P[0], P[4]), [-0.2, 0, 0]), label: "38\"" }, // height
  },

  // From FloorMapPanel kitchen room (kimbarkRooms.ts)
  cameraPos:    [-1.452, 0.266, 3.583],
  cameraLookAt: [5.279, 0.085, 7.023],

  items: [
    { label: 'Countertop',        modelQty: 35, unit: 'sq ft', wastePercent: 15 },
    { label: 'Countertop edge',   modelQty: 25, unit: 'lin ft', wastePercent: 10 },
    { label: 'Kitchen island',    modelQty: 1,  unit: 'ea',     wastePercent: 0  },
  ],
};
